export const UNITS = ["%", "hours", "days", "count", "$", "score", "ratio", "units"];

// Returns the Phase 1 metrics array, falling back to the legacy single-metric shape.
export function getMetrics(p1 = {}) {
  if (Array.isArray(p1.metrics) && p1.metrics.length) return p1.metrics;
  if (p1.metric_name || p1.desired_value !== undefined || p1.current_value !== undefined) {
    if (p1.metric_name || p1.desired_value !== "" || p1.current_value !== "") {
      return [{
        id: "legacy",
        name: p1.metric_name || "",
        current: p1.current_value ?? "",
        target: p1.desired_value ?? "",
        unit: "",
      }];
    }
  }
  return [];
}

export function metricGap(m) {
  const t = parseFloat(m.target);
  const c = parseFloat(m.current);
  return !isNaN(t) && !isNaN(c) ? t - c : null;
}
